import { setLocalLogout } from '../redux/slices/loginSlice'; // Adjust the import path as needed
// import { getRoleId, getRolePermission } from './RBAC';
import axios from 'axios';
import { toast } from 'react-toastify';
import { STORAGE_KEY } from './Constant';

export const refreshAuthToken = async (refreshToken: any) => {
  try {
    const response = await axios.post(`${process.env.REACT_APP_KEYCLOAK_URL}/realms/${process.env.REACT_APP_KEYCLOAK_REALM}/protocol/openid-connect/token`, new URLSearchParams({
      'client_id': process.env.REACT_APP_KEYCLOAK_CLIENT_ID ?? '',
      'client_secret': process.env.REACT_APP_KEYCLOAK_CLIENT_SECRET ?? '',
      'grant_type': 'refresh_token',
      'refresh_token': refreshToken
    }), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    });

    const newAccessToken = response.data.access_token;
    const tokenPayload = JSON.parse(atob(newAccessToken.split('.')[1]));

    const updatedData = {
      employeeName: tokenPayload.name,
      email: tokenPayload.email,
      accessToken: newAccessToken,
      accessExpiryTime: tokenPayload.exp,
      resetToken: response.data.refresh_token,
      resetExpiryTime: tokenPayload.exp,
      mobile_device_token: null,
    //   permissions: getRolePermission(tokenPayload),
    //   roleId: getRoleId(tokenPayload)?.roleId,
    //   roleName: getRoleId(tokenPayload)?.roleName,
      userId: tokenPayload?.sub,
      // sessionId: JSON.parse(localStorage.getItem('app-auth')?? '').sessionId
    };
    // Update local storage with new access token and user data
    // localStorage.setItem('app-auth', JSON.stringify(updatedData));

    // Update Redux state
    // dispatch(setAuthenticated({
    //   status: LOGIN_STATUS.AUTHENTICATED,
    //   user: updatedData,
    // }));
    localStorage.setItem(STORAGE_KEY.AUTH_DATA, JSON.stringify(updatedData));
    return newAccessToken;

  } catch (error) {
    console.error('Error refreshing token:', error);
    toast.error('Session expired')
    localStorage.clear();
    setLocalLogout({});
    // dispatch(setLocalLogout({}));
    window.location.href = '/';
  }
};

export const getAdminTokenApi = async () => {
    const response = await axios.post(`${process.env.REACT_APP_KEYCLOAK_URL}/realms/${process.env.REACT_APP_KEYCLOAK_REALM}/protocol/openid-connect/token`, new URLSearchParams({
      'client_id': process.env.REACT_APP_KEYCLOAK_CLIENT_ID ?? '',
      'client_secret': process.env.REACT_APP_KEYCLOAK_CLIENT_SECRET ?? '',
      'grant_type': 'client_credentials'
    }), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    });

    const token = response.data.access_token;
    const tokenPayload = JSON.parse(atob(token.split('.')[1]));
    const expiryTime = tokenPayload.exp;

    return {token: token, expiryTime: expiryTime};
  };


export const invalidateExistingSessions = async (userId: any, adminToken: any, currentSession: any) => {
    const sessionsResponse = await axios.get(`${process.env.REACT_APP_KEYCLOAK_URL}/admin/realms/${process.env.REACT_APP_KEYCLOAK_REALM}/users/${userId}/sessions`, {
      headers: {
        'Authorization': `Bearer ${adminToken}`
      }
    });
  
    const sessions = sessionsResponse.data;
    const clientName = process.env.REACT_APP_KEYCLOAK_CLIENT_ID;
  
    for (const session of sessions) {
      const sessionClients = session?.clients || {};
      const clientIds = Object.keys(sessionClients);
  
      for (const clientId of clientIds) {
        if (sessionClients[clientId] === clientName && session?.id !== currentSession) {
          await axios.delete(`${process.env.REACT_APP_KEYCLOAK_URL}/admin/realms/${process.env.REACT_APP_KEYCLOAK_REALM}/sessions/${session.id}`, {
            headers: {
              'Authorization': `Bearer ${adminToken}`
            }
          });
        }
      }
    }
  };

  export const getUserGroups = async (userId: string, adminToken: string) => {
    const response = await axios.get(`${process.env.REACT_APP_KEYCLOAK_URL}/admin/realms/${process.env.REACT_APP_KEYCLOAK_REALM}/users/${userId}/groups`, {
      headers: {
        'Authorization': `Bearer ${adminToken}`,
      },
    });
    return response.data.map((group: any) => ({
      id: group.id,
      name: group.name,
      path: group.path,
      parentId: group.parentId,
    }));
  };


export  const getGroupByName = async (groupName: string, adminToken: string) => {
  const response = await axios.get(`${process.env.REACT_APP_KEYCLOAK_URL}/admin/realms/${process.env.REACT_APP_KEYCLOAK_REALM}/groups`, {
    headers: {
      'Authorization': `Bearer ${adminToken}`,
    },
  });
  return response.data.find((group: any) => group.name === groupName);
};

export const getChildGroups = async (parentId: string, adminToken: string) => {
  let allChildGroups: any = [];
  let page = 0;
  const pageSize = 100; // Adjust this based on the API's limit

  while (true) {
    const response = await axios.get(`${process.env.REACT_APP_KEYCLOAK_URL}/admin/realms/${process.env.REACT_APP_KEYCLOAK_REALM}/groups/${parentId}/children`, {
      headers: {
        'Authorization': `Bearer ${adminToken}`,
      },
      params: {
        first: page * pageSize,
        max: pageSize,
        fields: 'id,name,path,parentId', // Specify the fields you want
      },
    });

    const childGroups = response.data;
    allChildGroups = allChildGroups.concat(childGroups);

    if (childGroups.length < pageSize) {
      break; // No more pages to fetch
    }

    page++;
  }

  return allChildGroups;
};

export const assignUserToGroup = async (userId: string, groupId: string, adminToken: string) => {
  await axios.put(`${process.env.REACT_APP_KEYCLOAK_URL}/admin/realms/${process.env.REACT_APP_KEYCLOAK_REALM}/users/${userId}/groups/${groupId}`, {}, {
    headers: {
      'Authorization': `Bearer ${adminToken}`,
    },
  });
};